<template>
  <eg-button
    :type="isSelected ? 'primary' : 'secondary'"
    :class="['eg-custom-radio', { 'eg-custom-radio--selected': isSelected }]"
    :size="size"
    v-bind="$attrs"
    :icon="icon"
    @click="$emit('click', $event)"
  >
    <template v-if="$slots.icon" #icon>
      <slot name="icon"></slot>
    </template>
    <slot></slot>
  </eg-button>
</template>

<script>
import EgButton from "./eg_button.vue";

export default {
  name: "EgCustomRadio",
  components: { EgButton },
  inheritAttrs: false,
  props: {
    isSelected: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "sm",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  emits: ["click"],
};
</script>

<style lang="scss" scoped>
.eg-custom-radio {
  white-space: nowrap;
}
</style>
